import { Action, createReducer, on } from '@ngrx/store';
import { CellularInterface, CellularInterfaceReducer } from '../cellular-interface.model';
import * as cellularInterfaceActions from './cellular-interface.action';

const initialState: CellularInterfaceReducer = {
  cellularInterfaces: [],
  columns: [
    { key: 'Name', field: 'user_defined_name', hide: false },
    { key: 'Runtime status', field: 'runtime_status', hide: false },
    { key: 'Runtime IP addresses', field: 'system_defined_ip_addresses', hide: false },
    { key: 'Network side', field: 'network_side', hide: false },
    { key: 'APN', field: 'apn', hide: false },
    { key: 'MTU', field: 'mtu', hide: false },
    { key: 'Connectivity state', field: 'connectivity_stats.state', hide: false },
    { key: 'Operator name', field: 'connectivity_stats.operator_name', hide: false },
    { key: 'Signal strength', field: 'connectivity_stats.signal_strength', hide: false },
    { key: 'TX-Packets', field: 'statistics.sent.packets', hide: false },
    { key: 'TX-Bytes', field: 'statistics.sent.bytes', hide: false },
    { key: 'TX-Errors', field: 'statistics.sent.errors', hide: false },
    { key: 'TX-Dropped', field: 'statistics.sent.dropped', hide: false },
    { key: 'RX-Packets', field: 'statistics.received.packets', hide: false },
    { key: 'RX-Bytes', field: 'statistics.received.bytes', hide: false },
    { key: 'RX-Errors', field: 'statistics.received.errors', hide: false },
    { key: 'RX-Dropped', field: 'statistics.received.dropped', hide: false },
  ],
  lastRefreshedAt: null,
};

const reducer = createReducer(
  initialState,

  on(cellularInterfaceActions.setCellularInterfaces, (state, props) => ({
    ...state,
    cellularInterfaces: props.cellularInterfaces,
  })),

  on(cellularInterfaceActions.updateCellularInterface, (state, props) => {
    return {
      ...state,
      cellularInterfaces: state.cellularInterfaces.map((cellularInterface: CellularInterface) =>
        cellularInterface.id === props.updatedCellularInterface.id
          ? props.updatedCellularInterface
          : cellularInterface
      ),
    };
  }),

  on(cellularInterfaceActions.updateSelectedColumns, (state, props) => {
    const selectedFields = props.selectedColumns.map((col) => col.field);

    return {
      ...state,
      columns: state.columns.map((column) =>
        selectedFields.includes(column.field) ? { ...column, hide: false } : column
      ),
    };
  }),

  on(cellularInterfaceActions.updateUnselectedColumns, (state, props) => {
    const unselectedFields = props.unselectedColumns.map((col) => col.field);

    return {
      ...state,
      columns: state.columns.map((column) =>
        unselectedFields.includes(column.field) ? { ...column, hide: true } : column
      ),
    };
  }),

  on(cellularInterfaceActions.clearCellularInterface, () => initialState),

  on(cellularInterfaceActions.updateLastRefreshedAt, (state, props) => ({
    ...state,
    lastRefreshedAt: props.lastRefreshedAt,
  }))
);

export function cellularInterfacesReducer(
  state: CellularInterfaceReducer | undefined,
  action: Action
) {
  return reducer(state, action);
}
